export default {
    permissions: '/security/users/current/permissions',
};
